/*
if status is either ACTIVE or INACTIVE, all 3 sections under Lead Capture are visible
*/
import React, { useState, useEffect } from "react";
import "../styles/Header.css";
import { Toaster } from "react-hot-toast";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useMatch,
  useParams,
  useNavigate,
  useLocation,
  Outlet,
} from "react-router-dom";
import { useWindowSize } from "../hooks/useWindowSize";

function Header(props) {
  var path = useLocation();
  const { width } = useWindowSize();

  useEffect(() => {
    if (
      typeof props !== "undefined" &&
      props !== null &&
      typeof props.userProfile !== "undefined" &&
      props.userProfile !== null &&
      props.userProfile.status !== "ACTIVE"
    ) {
      var pika = document.getElementById("customize-widget-header-option");
      if (pika) {
        pika.style = "display: none";
      }
    }
  }, [path]);

  const SideBar = (props) => {
    const { width } = useWindowSize();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const actionSidebar = (value) => {
      setIsMenuOpen(value);
      document.getElementById("sidebar_menu").style.width = value
        ? width > 489
          ? "340px"
          : "100vw"
        : "0";
    };
    useEffect(() => {
      if (isMenuOpen) {
        if (width <= 489) {
          document.getElementById("sidebar_menu").style.width = "100vh";
        } else {
          document.getElementById("sidebar_menu").style.width = "340px";
        }
      }
    }, [width]);

    return (
      <div>
        <button className="header-menu-btn" onClick={() => actionSidebar(true)}>
          <span className="mdi mdi-menu" />
        </button>
        <div id="sidebar_menu">
          <button
            className="header-menu-btn close"
            onClick={() => actionSidebar(false)}
          >
            <span className="mdi mdi-close" />
          </button>
          <MainNenu {...props} />
          {props.authFlag && (
            <div className="header-items-container">
              <ul className="header-items">
                <Link to="/">Account Management</Link>
              </ul>
              {props.authFlag && (
                <div className="header-dropdown left">
                  <ul className="header-items">
                    <li
                      className="header-item"
                      onClick={() => {
                        window.location.href = "/paymentmethods";
                      }}
                    >
                      Payment methods
                    </li>
                    <li
                      className="header-item"
                      onClick={() => {
                        window.location.href = "/integration";
                      }}
                    >
                      Integrations
                    </li>
                    <li onClick={props.signOut}>Sign out</li>
                  </ul>
                </div>
              )}
            </div>
          )}
          <div className="header-items-container">
            {/* THE WAY BACK. This site had none for a logged-out visitor: every
                route here is realtors.honely.com, so arriving from the main
                site's "Realtors" link was a one-way trip. A "Go to Honely.com"
                did exist, but only after sign-in and sitting between "API
                Documentation" and "Sign out" -- a cross-site exit dressed as an
                ordinary menu item, which is the thing to avoid.

                So it sits at the EDGE of the bar, ahead of the divider, and
                carries an arrow rather than a label that reads like navigation
                within this app. Special links go on one side; they do not hide
                in the middle of the menu. */}
            <a
              className="header-backlink"
              href="https://www.honely.com"
            >
              <span className="mdi mdi-arrow-left" />
              Honely.com
            </a>
            {!props.authFlag && (
              <div className="header-signout">
                <button
                  onClick={() => {
                    window.location.href = "/signup";
                  }}
                >
                  Sign up
                </button>
              </div>
            )}
            {!props.authFlag && (
              <div
                className="header-signout"
                id="header-signin"
                onClick={() => {
                  window.location.href = "/signin";
                }}
              >
                <span>Log in</span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const MainNenu = (props) => {
    return (
      <div className="header-items-container">
        <nav>
          <ul className="header-items">
            <li
              className={`header-item ${
                path.pathname === "/leadgen" ? "active" : ""
              }`}
              onMouseOver={() => {
                if (
                  props.authFlag &&
                  (props.userProfile.status === "ACTIVE" ||
                    props.userProfile.status === "INACTIVE")
                ) {
                  document
                    .getElementById("header-dropdown-left")
                    .classList.add("active");
                }
              }}
              onMouseLeave={() => {
                if (
                  props.authFlag &&
                  (props.userProfile.status === "ACTIVE" ||
                    props.userProfile.status === "INACTIVE")
                ) {
                  document
                    .getElementById("header-dropdown-left")
                    .classList.remove("active");
                }
              }}
            >
              <Link to="/leadgen">Lead Capture</Link>
              {props.authFlag && (
                <div className="header-dropdown left" id="header-dropdown-left">
                  <ul>
                    {(props.userProfile.status === "ACTIVE" ||
                      props.userProfile.status === "INACTIVE") && (
                      <li
                        onClick={() => {
                          window.location.href = "/account-management/leads";
                        }}
                      >
                        Leads
                      </li>
                    )}
                    {(props.userProfile.status === "ACTIVE" ||
                      props.userProfile.status === "INACTIVE") && (
                      <li
                        onClick={() => {
                          window.location.href =
                            "/account-management/customize-widget";
                        }}
                      >
                        Customize Widget
                      </li>
                    )}
                    {(props.userProfile.status === "ACTIVE" ||
                      props.userProfile.status === "INACTIVE") && (
                      <li
                        onClick={() => {
                          window.location.href =
                            "/account-management/subscription";
                        }}
                      >
                        Subscription
                      </li>
                    )}
                  </ul>
                </div>
              )}
            </li>
            <li
              className={`header-item ${
                path.pathname === "/reports" ? "active" : ""
              }`}
              // onMouseOver = {() => {
              //   document.getElementById('header-dropdown-right').classList.add('active')
              // }}
              // onMouseLeave = {() => {
              //   document.getElementById('header-dropdown-right').classList.remove('active')
              // }}
            >
              <Link to="/reports">Report Generation</Link>
              {/* {
                props.authFlag &&
                <div className="header-dropdown right" id="header-dropdown-right">
                  <ul>
                    <li>New Report</li>
                    <li>Archived Reports</li>
                  </ul>
                </div>
              } */}
            </li>
          </ul>
        </nav>
      </div>
    );
  };

  return (
    <div className="header-container" style={{ width: "100%" }}>
      <Toaster position="bottom-center" reverseOrder={false} />
      <div className="logo-wrapper">
        {props?.userProfile?.partner_company_logo ? (
          <img
            style={{ width: 200, objectFit: "contain", cursor: "pointer" }}
            onClick={() => {
              window.location.href = "/";
            }}
            src={props?.userProfile?.partner_company_logo}
            alt=""
          />
        ) : (
          <svg
            width="100"
            height="50"
            viewBox="0 0 150 75"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={() => {
              window.location.href = "/";
            }}
            style={{ cursor: "pointer" }}
          >
            <path
              d="M45.7916 65V54.0909H49.4724C50.1826 54.0909 50.7739 54.2152 51.2462 54.4638C51.722 54.7124 52.0789 55.0515 52.3169 55.4812C52.5548 55.9109 52.6737 56.3991 52.6737 56.946C52.6737 57.4006 52.5974 57.7894 52.4447 58.1126C52.292 58.4357 52.0843 58.6967 51.8215 58.8956C51.5587 59.0945 51.2657 59.2383 50.9426 59.3271V59.4123C51.2941 59.4371 51.635 59.5614 51.9653 59.7852C52.2955 60.0053 52.5672 60.3143 52.7803 60.712C52.9933 61.1097 53.0999 61.5856 53.0999 62.1396C53.0999 62.69 52.9774 63.1818 52.7323 63.6151C52.4873 64.0447 52.1109 64.3839 51.6031 64.6325C51.0988 64.8775 50.4561 65 49.6748 65H45.7916ZM46.7877 64.1051H49.6748C50.5164 64.1051 51.1379 63.9187 51.5392 63.5458C51.944 63.1729 52.1464 62.7042 52.1464 62.1396C52.1464 61.7241 52.0452 61.3477 51.8428 61.0103C51.6439 60.6694 51.3616 60.3995 50.9958 60.2006C50.6336 60.0018 50.2075 59.9023 49.7174 59.9023H46.7877V64.1051ZM46.7877 59.0181H49.5629C49.9926 59.0181 50.3691 58.9293 50.6922 58.7518C51.0154 58.5742 51.2675 58.3292 51.4486 58.0167C51.6297 57.7042 51.7203 57.3473 51.7203 56.946C51.7203 56.3672 51.532 55.8967 51.1556 55.5344C50.7792 55.1687 50.2181 54.9858 49.4724 54.9858H46.7877V59.0181ZM60.5053 61.8732V56.8182H61.4535V65H60.5053V63.6417H60.4308C60.239 64.0607 59.9354 64.4105 59.5199 64.6911C59.1044 64.968 58.5966 65.1065 57.9964 65.1065C57.4744 65.1065 57.011 64.9929 56.6062 64.7656C56.2013 64.5348 55.8835 64.1974 55.6527 63.7536C55.4219 63.3097 55.3065 62.7646 55.3065 62.1183V56.8182H56.2546V62.0597C56.2546 62.6989 56.4428 63.2138 56.8192 63.6044C57.1957 63.9915 57.6786 64.185 58.2681 64.185C58.6374 64.185 58.9925 64.0962 59.3335 63.9187C59.6744 63.7411 59.9549 63.4819 60.1751 63.141C60.3952 62.7965 60.5053 62.3739 60.5053 61.8732ZM69.4608 58.6133L68.5926 58.8583C68.5074 58.6133 68.3866 58.3913 68.2304 58.1925C68.0741 57.9936 67.8699 57.8356 67.6178 57.7184C67.3692 57.6012 67.0603 57.5426 66.691 57.5426C66.137 57.5426 65.6824 57.674 65.3273 57.9368C64.9722 58.1996 64.7947 58.5387 64.7947 58.9542C64.7947 59.3058 64.9154 59.5916 65.1569 59.8118C65.4019 60.0284 65.7783 60.2006 66.2861 60.3285L67.5219 60.6321C68.2073 60.799 68.7204 61.0636 69.0613 61.4258C69.4058 61.788 69.578 62.2425 69.578 62.7894C69.578 63.2511 69.4502 63.6612 69.1945 64.0199C68.9388 64.3786 68.5819 64.6609 68.1238 64.8668C67.6693 65.0692 67.142 65.1705 66.5418 65.1705C65.7428 65.1705 65.0841 64.9911 64.5656 64.6325C64.0471 64.2702 63.7151 63.7482 63.5695 63.0664L64.4804 62.8427C64.5976 63.3292 64.8266 63.6967 65.1675 63.9453C65.512 64.1939 65.9648 64.3182 66.5258 64.3182C67.1544 64.3182 67.6569 64.1779 68.0333 63.8974C68.4097 63.6133 68.5979 63.2582 68.5979 62.832C68.5979 62.5018 68.4878 62.2248 68.2677 62.0011C68.0475 61.7738 67.7137 61.6069 67.2662 61.5004L65.9292 61.1808C65.219 61.0103 64.6934 60.7404 64.3525 60.3711C64.0116 60.0018 63.8412 59.5437 63.8412 58.9968C63.8412 58.5458 63.9637 58.1499 64.2087 57.8089C64.4537 57.4645 64.7911 57.1946 65.2208 56.9993C65.6505 56.804 66.1405 56.7063 66.691 56.7063C67.4403 56.7063 68.0386 56.8768 68.4861 57.2177C68.9371 57.555 69.262 58.0202 69.4608 58.6133ZM71.6648 65V56.8182H72.6183V65H71.6648ZM72.1495 55.4119C71.9542 55.4119 71.7873 55.3462 71.6488 55.2148C71.5103 55.0799 71.4411 54.9183 71.4411 54.7301C71.4411 54.5419 71.5103 54.3821 71.6488 54.2507C71.7873 54.1158 71.9542 54.0483 72.1495 54.0483C72.3448 54.0483 72.5117 54.1158 72.6502 54.2507C72.7887 54.3821 72.858 54.5419 72.858 54.7301C72.858 54.9183 72.7887 55.0799 72.6502 55.2148C72.5117 55.3462 72.3448 55.4119 72.1495 55.4119ZM76.074 59.8864V65H75.1258V56.8182H76.0473V58.1019H76.1325C76.3243 57.6829 76.6226 57.3473 77.0274 57.0952C77.4358 56.8395 77.9401 56.7116 78.5402 56.7116C79.0906 56.7116 79.5736 56.8271 79.9891 57.0579C80.4081 57.2852 80.733 57.6207 80.9639 58.0646C81.1982 58.5085 81.3154 59.0536 81.3154 59.6999V65H80.3673V59.7585C80.3673 59.0874 80.1791 58.5565 79.8026 58.1658C79.4298 57.7752 78.9291 57.5799 78.3005 57.5799C77.8708 57.5799 77.4891 57.6722 77.1553 57.8569C76.8215 58.0415 76.5569 58.3079 76.3616 58.6559C76.1698 59.0004 76.074 59.4105 76.074 59.8864ZM87.1202 65.1705C86.3567 65.1705 85.6962 64.9929 85.1387 64.6378C84.5811 64.2791 84.1497 63.7837 83.8443 63.1516C83.5424 62.516 83.3915 61.7844 83.3915 60.957C83.3915 60.1332 83.5424 59.4016 83.8443 58.7624C84.1497 58.1197 84.5705 57.6172 85.1067 57.255C85.6465 56.8892 86.2697 56.7063 86.9764 56.7063C87.4203 56.7063 87.8482 56.788 88.2601 56.9513C88.6721 57.1112 89.0414 57.358 89.3681 57.6918C89.6983 58.022 89.9593 58.4393 90.1511 58.9435C90.3429 59.4442 90.4387 60.0373 90.4387 60.7227V61.1914H84.0467V60.3551H89.4693C89.4693 59.8295 89.3627 59.3572 89.1497 58.9382C88.9402 58.5156 88.6472 58.1818 88.2708 57.9368C87.8979 57.6918 87.4664 57.5692 86.9764 57.5692C86.4579 57.5692 86.0016 57.7077 85.6074 57.9847C85.2132 58.2617 84.9043 58.6275 84.6806 59.082C84.4604 59.5366 84.3485 60.0337 84.345 60.5735V61.0742C84.345 61.7241 84.4569 62.2923 84.6806 62.7788C84.9078 63.2617 85.2292 63.6364 85.6447 63.9027C86.0602 64.169 86.552 64.3022 87.1202 64.3022C87.5073 64.3022 87.8464 64.2418 88.1376 64.1211C88.4324 64.0004 88.6792 63.8388 88.878 63.6364C89.0804 63.4304 89.2331 63.2049 89.3361 62.9599L90.2363 63.2528C90.112 63.5973 89.9078 63.9151 89.6238 64.2063C89.3432 64.4975 88.9917 64.7319 88.5691 64.9094C88.15 65.0835 87.6671 65.1705 87.1202 65.1705ZM98.0253 58.6133L97.157 58.8583C97.0718 58.6133 96.9511 58.3913 96.7948 58.1925C96.6386 57.9936 96.4344 57.8356 96.1823 57.7184C95.9337 57.6012 95.6247 57.5426 95.2554 57.5426C94.7014 57.5426 94.2469 57.674 93.8918 57.9368C93.5367 58.1996 93.3591 58.5387 93.3591 58.9542C93.3591 59.3058 93.4798 59.5916 93.7213 59.8118C93.9664 60.0284 94.3428 60.2006 94.8506 60.3285L96.0864 60.6321C96.7718 60.799 97.2849 61.0636 97.6258 61.4258C97.9703 61.788 98.1425 62.2425 98.1425 62.7894C98.1425 63.2511 98.0146 63.6612 97.759 64.0199C97.5033 64.3786 97.1464 64.6609 96.6883 64.8668C96.2338 65.0692 95.7064 65.1705 95.1063 65.1705C94.3073 65.1705 93.6485 64.9911 93.1301 64.6325C92.6116 64.2702 92.2796 63.7482 92.134 63.0664L93.0448 62.8427C93.162 63.3292 93.3911 63.6967 93.732 63.9453C94.0764 64.1939 94.5292 64.3182 95.0903 64.3182C95.7188 64.3182 96.2213 64.1779 96.5977 63.8974C96.9742 63.6133 97.1624 63.2582 97.1624 62.832C97.1624 62.5018 97.0523 62.2248 96.8321 62.0011C96.6119 61.7738 96.2781 61.6069 95.8307 61.5004L94.4937 61.1808C93.7835 61.0103 93.2579 60.7404 92.917 60.3711C92.5761 60.0018 92.4056 59.5437 92.4056 58.9968C92.4056 58.5458 92.5281 58.1499 92.7732 57.8089C93.0182 57.4645 93.3556 57.1946 93.7852 56.9993C94.2149 56.804 94.705 56.7063 95.2554 56.7063C96.0047 56.7063 96.6031 56.8768 97.0505 57.2177C97.5015 57.555 97.8264 58.0202 98.0253 58.6133ZM105.716 58.6133L104.847 58.8583C104.762 58.6133 104.642 58.3913 104.485 58.1925C104.329 57.9936 104.125 57.8356 103.873 57.7184C103.624 57.6012 103.315 57.5426 102.946 57.5426C102.392 57.5426 101.937 57.674 101.582 57.9368C101.227 58.1996 101.05 58.5387 101.05 58.9542C101.05 59.3058 101.17 59.5916 101.412 59.8118C101.657 60.0284 102.033 60.2006 102.541 60.3285L103.777 60.6321C104.462 60.799 104.975 61.0636 105.316 61.4258C105.661 61.788 105.833 62.2425 105.833 62.7894C105.833 63.2511 105.705 63.6612 105.449 64.0199C105.194 64.3786 104.837 64.6609 104.379 64.8668C103.924 65.0692 103.397 65.1705 102.797 65.1705C101.998 65.1705 101.339 64.9911 100.82 64.6325C100.302 64.2702 99.97 63.7482 99.8244 63.0664L100.735 62.8427C100.852 63.3292 101.081 63.6967 101.422 63.9453C101.767 64.1939 102.22 64.3182 102.781 64.3182C103.409 64.3182 103.912 64.1779 104.288 63.8974C104.665 63.6133 104.853 63.2582 104.853 62.832C104.853 62.5018 104.743 62.2248 104.523 62.0011C104.302 61.7738 103.969 61.6069 103.521 61.5004L102.184 61.1808C101.474 61.0103 100.948 60.7404 100.607 60.3711C100.267 60.0018 100.096 59.5437 100.096 58.9968C100.096 58.5458 100.219 58.1499 100.464 57.8089C100.709 57.4645 101.046 57.1946 101.476 56.9993C101.905 56.804 102.395 56.7063 102.946 56.7063C103.695 56.7063 104.294 56.8768 104.741 57.2177C105.192 57.555 105.517 58.0202 105.716 58.6133Z"
              fill="#FFFFFF"
            />
            <path
              d="M64.1089 30.9798C64.1089 33.6304 63.529 35.9828 62.3694 38.037C61.2098 40.0581 59.636 41.6485 57.648 42.8081C55.66 43.9678 53.4236 44.5476 50.9387 44.5476C48.4537 44.5476 46.2173 43.9678 44.2293 42.8081C42.2413 41.6485 40.651 40.0581 39.4582 38.037C38.2986 35.9828 37.7188 33.6304 37.7188 30.9798C37.7188 28.2961 38.2986 25.9437 39.4582 23.9226C40.651 21.8683 42.2413 20.2614 44.2293 19.1018C46.2173 17.909 48.4537 17.3126 50.9387 17.3126C53.4236 17.3126 55.66 17.909 57.648 19.1018C59.636 20.2614 61.2098 21.8683 62.3694 23.9226C63.529 25.9437 64.1089 28.2961 64.1089 30.9798ZM59.139 30.9798C59.139 29.1575 58.7745 27.5837 58.0456 26.2584C57.3167 24.9 56.3227 23.8397 55.0637 23.0777C53.8378 22.2825 52.4628 21.8849 50.9387 21.8849C49.4146 21.8849 48.023 22.2825 46.7639 23.0777C45.5049 23.8397 44.5109 24.9 43.782 26.2584C43.0531 27.5837 42.6886 29.1575 42.6886 30.9798C42.6886 32.7358 43.0531 34.2931 43.782 35.6515C44.5109 37.0099 45.5049 38.0702 46.7639 38.8322C48.023 39.5943 49.4146 39.9753 50.9387 39.9753C52.4628 39.9753 53.8378 39.5943 55.0637 38.8322C56.3227 38.0702 57.3167 37.0099 58.0456 35.6515C58.7745 34.2931 59.139 32.7358 59.139 30.9798Z"
              fill="#24CB43"
            />
            <path
              d="M80.2206 17.3126C82.573 17.3126 84.3953 17.8096 85.6875 18.8036C86.9797 19.7644 87.8743 21.0732 88.3712 22.7298C88.9014 24.3533 89.1664 26.1756 89.1664 28.1967V41.516C89.1664 42.2449 88.9179 42.8578 88.4209 43.3548C87.9571 43.8187 87.3773 44.0506 86.6815 44.0506C85.9526 44.0506 85.3562 43.8187 84.8923 43.3548C84.4285 42.8578 84.1965 42.2449 84.1965 41.516V28.2464C84.1965 27.0536 84.0309 25.9934 83.6995 25.0656C83.3682 24.1048 82.7884 23.3427 81.9601 22.7795C81.1649 22.1831 80.0384 21.8849 78.5806 21.8849C77.2221 21.8849 76.0293 22.1831 75.0022 22.7795C73.9751 23.3427 73.1634 24.1048 72.567 25.0656C72.0037 25.9934 71.7221 27.0536 71.7221 28.2464V41.516C71.7221 42.2449 71.4736 42.8578 70.9766 43.3548C70.5128 43.8187 69.9329 44.0506 69.2372 44.0506C68.5082 44.0506 67.9119 43.8187 67.448 43.3548C66.9841 42.8578 66.7522 42.2449 66.7522 41.516V20.4436C66.7522 19.7147 66.9841 19.1183 67.448 18.6545C67.9119 18.1575 68.5082 17.909 69.2372 17.909C69.9329 17.909 70.5128 18.1575 70.9766 18.6545C71.4736 19.1183 71.7221 19.7147 71.7221 20.4436V23.2268L70.8275 23.7238C71.0595 22.9949 71.457 22.2659 72.0203 21.537C72.6167 20.775 73.329 20.0792 74.1574 19.4497C74.9857 18.787 75.9134 18.2735 76.9405 17.909C77.9676 17.5114 79.061 17.3126 80.2206 17.3126Z"
              fill="#24CB43"
            />
            <path
              d="M105.261 44.5476C102.511 44.5476 100.126 43.9844 98.1045 42.8578C96.0834 41.6982 94.5096 40.1244 93.3831 38.1364C92.2897 36.1154 91.743 33.8126 91.743 31.2283C91.743 28.3126 92.3228 25.8277 93.4825 23.7735C94.6752 21.6861 96.2159 20.0957 98.1045 19.0024C99.993 17.8759 101.998 17.3126 104.118 17.3126C105.742 17.3126 107.282 17.6439 108.74 18.3066C110.198 18.9361 111.49 19.8307 112.617 20.9903C113.776 22.1168 114.687 23.4587 115.35 25.0159C116.013 26.54 116.361 28.2132 116.394 30.0355C116.361 30.6982 116.095 31.2449 115.598 31.6756C115.101 32.1063 114.522 32.3217 113.859 32.3217H94.5261L93.3334 28.0973H112.02L111.076 28.9919V27.7494C111.01 26.5897 110.629 25.5792 109.933 24.7177C109.237 23.8232 108.376 23.1439 107.348 22.6801C106.321 22.1831 105.245 21.9346 104.118 21.9346C103.124 21.9346 102.163 22.1003 101.235 22.4316C100.341 22.7298 99.5292 23.2268 98.8002 23.9226C98.1045 24.6183 97.5412 25.5461 97.1105 26.7057C96.7129 27.8322 96.5141 29.2403 96.5141 30.9301C96.5141 32.7524 96.8951 34.3428 97.6572 35.7012C98.4192 37.0596 99.4463 38.1199 100.738 38.8819C102.031 39.6108 103.455 39.9753 105.013 39.9753C106.239 39.9753 107.249 39.8593 108.044 39.6274C108.839 39.3624 109.502 39.0476 110.032 38.6831C110.562 38.3187 111.026 37.9708 111.424 37.6395C111.921 37.3413 112.418 37.1922 112.915 37.1922C113.511 37.1922 114.008 37.4075 114.406 37.8383C114.803 38.2358 115.002 38.7163 115.002 39.2795C115.002 40.0084 114.638 40.6711 113.909 41.2675C113.014 42.1289 111.772 42.891 110.181 43.5536C108.624 44.2163 106.984 44.5476 105.261 44.5476Z"
              fill="#24CB43"
            />
            <path
              d="M124.397 41.516C124.397 42.2449 124.148 42.8578 123.651 43.3548C123.187 43.8187 122.608 44.0506 121.912 44.0506C121.216 44.0506 120.62 43.8187 120.123 43.3548C119.659 42.8578 119.427 42.2449 119.427 41.516V9.80808C119.427 9.07916 119.675 8.48278 120.172 8.01892C120.669 7.52193 121.266 7.27344 121.961 7.27344C122.69 7.27344 123.27 7.52193 123.701 8.01892C124.165 8.48278 124.397 9.07916 124.397 9.80808V41.516Z"
              fill="#24CB43"
            />
            <path
              d="M147.516 17.7102C148.245 17.7102 148.841 17.9587 149.305 18.4557C149.769 18.9195 150.001 19.5159 150.001 20.2448V41.6154C150.001 44.531 149.438 46.9 148.311 48.7223C147.218 50.5446 145.727 51.8699 143.838 52.6982C141.983 53.5597 139.879 53.9904 137.527 53.9904C136.334 53.9904 135.141 53.8744 133.948 53.6425C132.755 53.4437 131.778 53.1455 131.016 52.7479C130.221 52.3835 129.658 51.9362 129.326 51.4061C128.995 50.8759 128.945 50.2961 129.177 49.6666C129.409 48.8714 129.807 48.3247 130.37 48.0265C130.933 47.7615 131.513 47.7449 132.109 47.9768C132.673 48.2088 133.418 48.5069 134.346 48.8714C135.274 49.2359 136.334 49.4181 137.527 49.4181C139.15 49.4181 140.525 49.153 141.652 48.6229C142.778 48.0928 143.623 47.2645 144.186 46.138C144.783 45.0115 145.081 43.5536 145.081 41.7645V38.3352L145.876 39.528C145.346 40.6214 144.65 41.5325 143.789 42.2615C142.927 42.9904 141.9 43.5536 140.707 43.9512C139.548 44.3488 138.255 44.5476 136.831 44.5476C135.008 44.5476 133.435 44.15 132.109 43.3548C130.817 42.5265 129.823 41.4 129.127 39.9753C128.432 38.5175 128.084 36.8608 128.084 35.0054V20.2448C128.084 19.5159 128.316 18.9195 128.78 18.4557C129.243 17.9587 129.84 17.7102 130.569 17.7102C131.264 17.7102 131.844 17.9587 132.308 18.4557C132.805 18.9195 133.054 19.5159 133.054 20.2448V33.6635C133.054 35.8503 133.534 37.4572 134.495 38.4843C135.456 39.4783 136.88 39.9753 138.769 39.9753C140.028 39.9753 141.121 39.7102 142.049 39.1801C142.977 38.65 143.706 37.9211 144.236 36.9934C144.766 36.0325 145.031 34.9226 145.031 33.6635V20.2448C145.031 19.5159 145.263 18.9195 145.727 18.4557C146.224 17.9587 146.82 17.7102 147.516 17.7102Z"
              fill="#24CB43"
            />
            <path
              d="M10.0781 0.83528C12.2257 1.17403 14.4222 2.87117 14.6838 5.48699C11.4783 2.4485 8.56058 6.14918 5.9402 6.21007C2.90171 6.28068 0.424783 4.73131 0 0C1.76059 2.14115 3.43244 2.77229 5.93982 1.51665C7.21726 0.87694 8.18689 0.536962 10.0781 0.83528Z"
              fill="#24CB43"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.7758 7.62109C16.1794 7.62109 17.3172 8.75893 17.3172 10.1625V41.7891C17.3172 43.1927 16.1794 44.3305 14.7758 44.3305C13.3722 44.3305 12.2344 43.1927 12.2344 41.7891V10.1625C12.2344 8.75893 13.3722 7.62109 14.7758 7.62109ZM31.981 19.9809C33.3846 19.9809 34.5224 21.1187 34.5224 22.5223V41.7891C34.5224 43.1927 33.3846 44.3305 31.981 44.3305C30.5774 44.3305 29.4396 43.1927 29.4396 41.7891V22.5223C29.4396 21.1187 30.5774 19.9809 31.981 19.9809Z"
              fill="#24CB43"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.8305 25.8476L9.60433 23.6215C8.37814 21.3955 8.37826 21.3954 8.37841 21.3953L8.51919 21.318C8.61 21.2682 8.74281 21.1955 8.91208 21.1032C9.25059 20.9186 9.73524 20.6554 10.3219 20.3396C11.494 19.7088 13.0783 18.8657 14.7198 18.021C16.3551 17.1794 18.0739 16.3223 19.5068 15.6705C20.2199 15.3462 20.8975 15.0564 21.4765 14.8428C21.765 14.7363 22.0619 14.6364 22.3464 14.5601C22.5891 14.4951 22.9949 14.3984 23.441 14.3984C23.9014 14.3984 24.3104 14.5006 24.5611 14.5729C24.8473 14.6554 25.1368 14.7624 25.4097 14.8737C25.9564 15.0966 26.5782 15.3954 27.2168 15.7238C28.5011 16.3844 30.0161 17.2493 31.4428 18.0934C32.8767 18.9417 34.2528 19.7877 35.2684 20.4203C35.7769 20.737 36.1964 21.0011 36.4895 21.1865C36.6361 21.2791 36.7511 21.3522 36.8299 21.4023L36.952 21.4802L36.9526 21.4805C36.9527 21.4806 36.9528 21.4807 35.5833 23.6215L36.9526 21.4805C38.1349 22.2369 38.4805 23.8087 37.7241 24.9911C36.9677 26.1734 35.3961 26.5187 34.2137 25.7624L34.1013 25.6907C34.0262 25.6429 33.9152 25.5724 33.7729 25.4824C33.4881 25.3023 33.0784 25.0444 32.5812 24.7347C31.5854 24.1145 30.2442 23.2901 28.8547 22.468C27.4581 21.6417 26.0436 20.8361 24.892 20.2439C24.3127 19.9459 23.8399 19.7227 23.4906 19.5803C23.4625 19.5688 23.4362 19.5583 23.4115 19.5486C23.3596 19.5664 23.3014 19.5872 23.2364 19.6112C22.8254 19.7629 22.2754 19.9952 21.6113 20.2972C20.2898 20.8983 18.6561 21.7116 17.0456 22.5404C15.4412 23.3661 13.8864 24.1934 12.7308 24.8154C12.1535 25.1261 11.6772 25.3848 11.3457 25.5656C11.1799 25.656 11.0505 25.7269 10.9628 25.775L10.8305 25.8476ZM23.7127 19.4576C23.7125 19.4578 23.7061 19.4593 23.6942 19.4615C23.7069 19.4585 23.7129 19.4574 23.7127 19.4576ZM23.1438 19.4542C23.1316 19.4516 23.1252 19.4498 23.125 19.4496C23.1248 19.4494 23.1309 19.4507 23.1438 19.4542ZM7.37828 24.8477C6.70108 23.6183 7.149 22.0725 8.37841 21.3953L9.60433 23.6215L10.8305 25.8476C9.60111 26.5248 8.05548 26.0771 7.37828 24.8477Z"
              fill="#24CB43"
            />
          </svg>
        )}
      </div>
      {width > 992 && (
        <>
          <MainNenu {...props} />
          <div className="header-right-items" style={{ minWidth: "110px" }}>
            {props.authFlag && (
              <div className="account-management-items">
                <ul>
                  <li
                    className={`header-item`}
                    onMouseOver={() => {
                      document
                        .getElementById("header-dropdown-account")
                        .classList.add("active");
                    }}
                    onMouseLeave={() => {
                      document
                        .getElementById("header-dropdown-account")
                        .classList.remove("active");
                    }}
                  >
                    <Link to="/">Account Management</Link>
                    {props.authFlag && (
                      <div
                        className="header-dropdown account"
                        id="header-dropdown-account"
                      >
                        <ul>
                          {/* <li>User Profile</li>
                      <li>Change Password</li> */}
                          <li
                            onClick={() => {
                              window.location.href = "/paymentmethods";
                            }}
                          >
                            Payment methods
                          </li>
                          <li
                            onClick={() => {
                              window.location.href = "/integration";
                            }}
                          >
                            Integrations
                          </li>
                          <li onClick={props.signOut}>Sign out</li>
                        </ul>
                      </div>
                    )}
                  </li>
                </ul>
                {/* <div id="header-signout">
              <span className="mdi mdi-power" />
              Sign out
            </div> */}
              </div>
            )}
            {/* Same exit as the mobile sidebar's. It has to be repeated because
                this component renders the bar twice -- SideBar for narrow
                viewports and this main return for desktop -- and patching only
                the first one shipped a bundle where the link existed in the
                source and not in the DOM. */}
            <a className="header-backlink" href="https://www.honely.com">
              <span className="mdi mdi-arrow-left" />
              Honely.com
            </a>
            {!props.authFlag && (
              <div className="header-signout">
                <button
                  onClick={() => {
                    window.location.href = "/signup";
                  }}
                >
                  Sign up
                </button>
              </div>
            )}
            {!props.authFlag && (
              <div
                className="header-signout"
                id="header-signin"
                onClick={() => {
                  window.location.href = "/signin";
                }}
              >
                <span>Log in</span>
              </div>
            )}
          </div>
        </>
      )}
      {width <= 992 && <SideBar {...props} />}
    </div>
  );
}

export default Header;
